import React, { Component } from 'react';

import BlockWrapper from '../../../components/blocks/BlockWrapper';
import MainBlock from '../../../components/blocks/MainBlock';

export default class Blocks extends Component {

    constructor(props) {
        super(props);

        this.blocks = [
            {
                title: "We design content for transformation journeys",
                linkTarget: "#strategy",
                icon: "screenshot",
                text: (
                    <p>Does your company need inspirational stories around change? Do you want to engage larger groups of employees? Then TROI is your strategic partner to design the right transformational content and bring it to live.</p>
                ),
                video: ""
            },
            {
                title: "We produce business videos",
                linkTarget: "#content",
                icon: "film",
                text: (
                    <p>Do you want a partner who excels at creating strategic business videos? TROI delivers world class, full-service productions which communicate the intensity of your transformation ambitions.</p>
                ),
                video: ""
            },
            {
                title: "We orchestrate GameTraining technology",
                linkTarget: "#technology",
                icon: "dashboard",
                text: (
                    <p>Are you reaching your target audience inside the company? Do they have the opportunity to learn and practice through digital role plays? TROI's development team orchestrates technology to enable digital knowledge transfer and social collaboration.</p>
                ),
                video: ""
            }
        ];
    }

    render() {
        return (
            <BlockWrapper>
                {this.blocks.map((blockData, index) => (
                    <MainBlock key={index}
                        title={blockData.title}
                        linkTarget={blockData.linkTarget}
                        icon={blockData.icon}
                        text={blockData.text}
                        video={blockData.video}>
                    </MainBlock>
                ))}
            </BlockWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/parts/companies/Blocks.js